/**
 * Single source of truth for the admin console mock surface.
 * Generated deterministically from fixed seeds — refresh-stable.
 */
import {
  generateAdminInvoiceRows,
  generateApprovalRequests,
  generateAuditEvents,
  generateCertificates,
  generateHsmStatus,
  generateIntegrationEvents,
  generateNotifications,
  generatePeppolDirectory,
  generateTickstarApiMatrix,
  generateTickstarDlq,
  generateTickstarSlaCards,
  generateTickstarUsage,
  generateTickstarWebhooks,
  generateReports,
  generateSampleInvoices,
  generateSampleTenants,
  generateSystemHealth,
  generateTddSubmissions,
  generateUnspscEntries,
  generateValidationRules,
  type AccreditationReport,
  type AdminInvoiceRow,
  type ApprovalRequest,
  type AuditEvent,
  type IntegrationEvent,
  type PeppolParticipant,
  type TickstarApiEndpoint,
  type TickstarDlqEntry,
  type TickstarSlaCard,
  type TickstarUsageSnapshot,
  type TickstarWebhookEvent,
  type SampleCertificate,
  type SampleHsm,
  type SampleInvoice,
  type SampleNotification,
  type SampleTenant,
  type SystemHealth,
  type TddSubmission,
  type UnspscEntry,
  type ValidationRule,
} from '@solara/sample-data';

export const MOCK_TENANTS: SampleTenant[] = generateSampleTenants(25);

/** Cross-tenant invoice list — 60 rows. */
export const MOCK_INVOICE_ROWS: AdminInvoiceRow[] = generateAdminInvoiceRows(
  60,
  MOCK_TENANTS.map((t) => ({
    tenantId: t.tenantId,
    companyNameEn: t.companyNameEn,
    companyNameAr: t.companyNameAr,
  })),
);

/** Per-tenant invoice samples (used on the invoice detail). */
export const MOCK_INVOICES: SampleInvoice[] = generateSampleInvoices(35);
export const MOCK_TDD: TddSubmission[] = generateTddSubmissions(MOCK_INVOICES);

export const MOCK_RULES: ValidationRule[] = generateValidationRules();
export const MOCK_HEALTH: SystemHealth = generateSystemHealth();
export const MOCK_INTEGRATION_EVENTS: IntegrationEvent[] = generateIntegrationEvents(40);
export const MOCK_CERTS: SampleCertificate[] = generateCertificates();
export const MOCK_HSM: SampleHsm = generateHsmStatus();
export const MOCK_REPORTS: AccreditationReport[] = generateReports(22);
export const MOCK_AUDIT: AuditEvent[] = generateAuditEvents(40);
export const MOCK_NOTIFICATIONS: SampleNotification[] = generateNotifications(18);
export const MOCK_APPROVALS: ApprovalRequest[] = generateApprovalRequests(8);

/** TickStar partner-bridge fixtures (active provider, see [[solara-tickstar-swap]]). */
export const MOCK_TICKSTAR_API: TickstarApiEndpoint[] = generateTickstarApiMatrix();
export const MOCK_TICKSTAR_WEBHOOKS: TickstarWebhookEvent[] = generateTickstarWebhooks(40);
export const MOCK_TICKSTAR_SLA: TickstarSlaCard[] = generateTickstarSlaCards();
export const MOCK_TICKSTAR_USAGE: TickstarUsageSnapshot = generateTickstarUsage();
export const MOCK_TICKSTAR_DLQ: TickstarDlqEntry[] = generateTickstarDlq(14);

export const MOCK_PEPPOL_DIR: PeppolParticipant[] = generatePeppolDirectory(60);
export const MOCK_UNSPSC: UnspscEntry[] = generateUnspscEntries();

export function findTenant(tenantId: string): SampleTenant | undefined {
  return MOCK_TENANTS.find((t) => t.tenantId === tenantId);
}

export function findInvoiceRow(invoiceId: string): AdminInvoiceRow | undefined {
  return MOCK_INVOICE_ROWS.find((i) => i.invoiceId === invoiceId);
}

export function findInvoice(invoiceId: string): SampleInvoice | undefined {
  return MOCK_INVOICES.find((i) => i.invoiceId === invoiceId);
}
